import React from "react";
import PolicyLayout from "@/components/PolicyLayout";

export default function Delivery() {
  return (
    <PolicyLayout
      title="Delivery"
      description="UK tracked delivery on every PeptiChill order. Dispatched within one working day. 2–3 working days arrival."
      path="/delivery"
      eyebrow="Shipping & delivery"
      lastUpdated="February 2026"
    >
      <h2>Where we ship</h2>
      <p>
        PeptiChill currently ships to addresses within the United Kingdom (England,
        Scotland, Wales and Northern Ireland). For enquiries about international delivery,
        please <a href="/contact">contact our team</a>.
      </p>

      <h2>Pre-order dispatch timing</h2>
      <p>
        PeptiChill is currently on <strong>pre-order</strong>. The first batch ships from
        <strong> July 2026</strong>, in the order pre-orders are received. Once your unit
        leaves us, you&rsquo;ll receive an email with tracking. For pre-orders placed in the
        days immediately before shipping begins, please allow a short additional handling
        window.
      </p>

      <h2>Delivery method &amp; timing</h2>
      <p>
        All UK orders are sent via a <strong>tracked, signed-for courier service</strong>.
        Expected arrival is <strong>2–3 working days</strong> from dispatch. Once your order
        is on its way, we&rsquo;ll email you a tracking link so you can follow it to your door.
      </p>

      <h2>Delivery charges</h2>
      <p>
        Standard UK tracked delivery is included as a flat-rate charge displayed at
        checkout. Pricing for express or weekend delivery, where available, is shown at the
        same point.
      </p>

      <h2>If your order hasn&rsquo;t arrived</h2>
      <p>
        If your tracking has not updated or your order has not arrived within{" "}
        <strong>5 working days</strong> of dispatch, please get in touch with our team at
        {" "}
        <a href="mailto:hello@peptidecooler.co.uk">hello@peptidecooler.co.uk</a>{" "}
        and we&rsquo;ll investigate with the carrier on your behalf. We may ask for your order
        reference and delivery address so we can act quickly.
      </p>

      <h2>Damaged or incorrect items</h2>
      <p>
        If your PeptiChill arrives damaged in transit, please don&rsquo;t use the product and
        contact us within <strong>48 hours</strong> with photos. We&rsquo;ll arrange a
        replacement or refund in line with our{" "}
        <a href="/returns">returns policy</a>.
      </p>

      <p className="text-sm text-muted">
        {/* [REVIEW] — confirm exact carrier name(s) (Royal Mail Tracked 24/48 / DPD / Evri) once finalised. */}
      </p>
    </PolicyLayout>
  );
}
